import * as React from 'react';

import '../Main.scss';

import {
    Row,
    Col,
} from 'reactstrap';

import { GetUnsafeContentMessage } from '../../Utils/FormUtils';
import { DangerousInput } from './DangerousInputForm';

import { PortalTextCommon } from '../../Models/Api/strongbox.financialportal';

type Props = {
    id: string;
    name: string;
    nameForInvalidMsg: string;
    value: string;
    maxLength?: number;
    clearFieldWithDangerousContent: () => void;
    updateField: (newValue: string) => void;
    fieldWithDangerousContent?: DangerousInput;
    required?: boolean;
    rows?: number;
    cols?: number;
    style?: React.CSSProperties;
    commonText?: PortalTextCommon;
};

export const PotentiallyDangerousTextArea: React.FC<Props> = (props): React.ReactElement => {
    const {
        id,
        value,
        clearFieldWithDangerousContent,
        updateField,
        maxLength,
        fieldWithDangerousContent,
        nameForInvalidMsg,
        rows,
        cols,
        style,
        required,
        commonText,
    } = props;

    const invalidMsg = React.useMemo(() => {
        return GetUnsafeContentMessage(nameForInvalidMsg, commonText);
        
        // This is the appropriate list of dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [nameForInvalidMsg]);

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <textarea
                        id={id}
                        value={value}
                        onChange={(e) => {
                            clearFieldWithDangerousContent();
                            updateField(e.currentTarget.value);
                        }}
                        maxLength={maxLength}
                        cols={cols}
                        rows={rows}
                        style={style}
                        required={!!required}
                    />
                </Col>
                {
                    !!fieldWithDangerousContent && (fieldWithDangerousContent.fieldId === id) && (
                        <Row>
                            <Col>
                                <span className={'error-text'}>{invalidMsg}</span>
                            </Col>
                        </Row>
                    )
                }
            </Row>
        </React.Fragment>
    );
}
